import { AxiosInstance } from 'axios'
import { catalogManagerApi } from '@root/api/api'
import { categoryRequestParams, reqHeaders } from '@shared/config/constants'
import { axiosProxyInstance } from '@api/axios.cjs'
import { filterPayeesForSearch } from '../lib/filterPayeesForSearch'

export async function fetchPayees() {
  const { requestId, categoryName, showHidden, showFromHiddenCategories } = categoryRequestParams

  const response = await catalogManagerApi.getPayees(
    'anonymous',
    undefined,
    undefined,
    categoryName,
    showHidden,
    showFromHiddenCategories,
    {
      headers: { ...reqHeaders, 'Request-id': requestId },
    },
    axiosProxyInstance as AxiosInstance
  )

  const servicesForSearch = filterPayeesForSearch(response?.data?.payees)

  return { response, servicesForSearch }
}
